export default {
    namespaced: true,

    state: {
        user: {},
    },

    getters: {
        getUser(state) {
            return state.user
        },
    },

    mutations: {
        setUser(state, user) {
            state.user = user
        },

        clearUser(state) {
            state.user = {}
        },
    },

    actions: {
        setUser(Store, user) {
            Store.commit('setUser', user)
        },

        clearSession(Store) {
            Store.commit('clearUser')
        },
    },
}
